import { atom } from 'jotai';
import update, { extend } from 'immutability-helper';
import { cloneDeep, set as loSet, unset as loUnset } from 'lodash';

interface ContextType {
  action: '$set' | '$unset';
  path: string[];
  data: any;
}

export const exportDataAtom = atom({});

const updateMap = {
  $set: (key, data) => ({ [key] : { $set : data }}),
  $unset: (key) => ({ $unset: [key] }),
};

// auto vivification for objects
extend('$auto', (value, object) => {
  return object ? update(object, value): update({}, value);
});

// clonedeep works and is simple
// but immutability update would be more effcient
const createUpdateRule = ({ action, path, data }:ContextType) => {
  const keyPath = [...path];
  const baseRule = updateMap[action](keyPath.pop(), data);
  const rule = keyPath.reverse().reduce((acc: any, key: string) => ({ [key] : { $auto : acc} }), baseRule);
  return rule;
}

// lodash fallback
const loMap = {
  $set: loSet,
  $unset: loUnset,
}

const fallback = (clonedData, { action, path, data }:ContextType) => {
  loMap[action](clonedData, path, data);
}

export const updateExportDataAtom = atom(
  null,
  (get, set, context: ContextType) => {
    const exportData = get(exportDataAtom);
    let updatedExportData;

    try {
      const updateRule = createUpdateRule(context);
      updatedExportData = update(exportData, updateRule);
    }
    catch (err) {
      updatedExportData = cloneDeep(exportData);
      fallback(updatedExportData, context);
    }
    set(exportDataAtom, updatedExportData);
  }
);

